<div *ngIf="getClassificacaoInfo()">
  <mat-card class="consolidacao">
    <div class="text-primary" *ngIf="getClassificacaoInfo() as info">
      <div class="info-header-title">
        Classificação consolidada
      </div>
      <div class="text-subtitle">
        por <strong>{{ info.usuario }}</strong> em {{ info.data | date: 'dd/MM/yyyy' }}
      </div>
    </div>
  </mat-card>
</div>

<mat-card *ngIf="retificado" class="card-warning" style="margin-bottom: 16px;">
  <span>⚠️ A classificação gerada pelo sistema foi retificada pela unidade em decorrência de recurso deferido. Consultar os andamentos do concurso para o resultado definitivo.</span>
</mat-card>

<div *ngIf="!getClassificacaoInfo()" class="painel-header">
  <div class="header-content">
    <div class="header-text">
      <h2>Análise e Desempate de Candidatos</h2>
      <p class="mat-body-1">Revise a classificação e resolva os empates antes de consolidar.</p>
    </div>
    <button mat-flat-button color="primary" class="btn-instrucoes" (click)="toggleInstrucoes()">
      <mat-icon>{{ instrucoesExpandidas ? 'close' : 'help_outline' }}</mat-icon>
      {{ instrucoesExpandidas ? 'Fechar' : 'Instruções' }}
    </button>
  </div>
</div>

<mat-card *ngIf="instrucoesExpandidas && !getClassificacaoInfo()" class="card-instrucoes" [@slideDown]>
  <mat-card-content class="instrucoes-content">
    <div class="secao-instrucoes">
      <h3><mat-icon>description</mat-icon>Instruções para análise e desempate</h3>
      <ul>
        <li>Na coluna <strong>indicações</strong> é exibido o <strong>número de vezes em que o candidato obteve a melhor colocação</strong> na classificação individual de cada examinador.</li>
        <li>Em caso de <strong>empate</strong>, informe o <strong>conceito</strong> para desempate dos candidatos na respectiva coluna.</li>
        <li><strong>É obrigatório informar uma justificativa</strong> sempre que você inserir ou alterar um conceito para desempate.</li>
        <li>Para <strong>visualizar a justificativa</strong> de um conceito atribuído, <strong>posicione o mouse sobre o campo de conceito</strong> e ela será exibida.</li>
        <li><strong>Não é permitido utilizar o mesmo conceito</strong> para dois ou mais candidatos com a <strong>mesma nota</strong>. Cada um deve ter um conceito distinto.</li>
        <li>Após revisar toda a classificação, clique no botão <strong>"Consolidar Classificação"</strong> ao final da página. Esta ação é obrigatória e, uma vez realizada, a classificação final não poderá mais ser alterada.</li>
        <li>Antes de consolidar, certifique-se de que todas as médias e posições estão corretas. A consolidação definirá a classificação final do concurso.</li>
      </ul>
    </div>
  </mat-card-content>
</mat-card>

<mat-card *ngIf="existemEmpatesNaoResolvidos() && !getClassificacaoInfo()" class="alerta-empate-pendente">
  <mat-card-header>
    <mat-icon>warning</mat-icon>
    <mat-card-title>Atenção</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    Existem empates pendentes de resolução. Preencha os conceitos para todos os candidatos empatados utilizando letras em ordem alfabética.
  </mat-card-content>
</mat-card>

<mat-card *ngIf="!existemEmpatesNaoResolvidos() && !getClassificacaoInfo()" class="alerta-empate-resolvido">
  <mat-card-header>
    <mat-icon>check_circle</mat-icon>
    <mat-card-title>Concluído</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    A classificação está pronta para consolidação.
  </mat-card-content>
</mat-card>

<div class="tables-container">    

  <div class="notes-block" *ngIf="dataSource && dataSource.data && dataSource.data.length > 0">
    <div class="title">
      <mat-icon>emoji_events</mat-icon>
      <span>Classificação Final</span>
    </div>
    
    <div class="botoes-classificacao mb-16">
      <button 
        mat-raised-button 
        [color]="tipoClassificacao === 'todos' ? 'primary' : ''"
        (click)="selecionarTipoClassificacao('todos')"
        class="mr-8">
        Todos os Candidatos
      </button>
      <button 
        *ngIf="exibirIconePCD()"
        mat-raised-button 
        [color]="tipoClassificacao === 'pcd' ? 'primary' : ''"
        (click)="selecionarTipoClassificacao('pcd')"
        class="mr-8">
        Candidatos PCD
      </button>
    </div>
    
    <table mat-table [dataSource]="dataSourceFiltrado" class="mat-elevation-z8">

      <ng-container matColumnDef="classificacao">
        <th class="col-classification" mat-header-cell *matHeaderCellDef>Classificação</th>
        <td class="col-classification" mat-cell *matCellDef="let row">
          <mat-icon *ngIf="row.estaEliminado" class="eliminated-icon" matTooltip="Não Habilitado">close</mat-icon>
          <span *ngIf="!row.estaEliminado">{{ row.classificacao }}º</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="inscricaoId">
        <th class="col-registration" mat-header-cell *matHeaderCellDef>Inscrição</th>
        <td class="col-registration" mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th class="col-name" mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
        <td class="col-name" mat-cell *matCellDef="let row">          
          <strong>{{ row.nomeSocial || row.nome }}</strong>
          <mat-icon *ngIf="row.jurado && !row.documentoJuradoInvalido" class="jury-icon clickable" matTooltip="Jurado - Clique para ver documento" (click)="visualizarDocumentoJurado(row.inscricaoId)">gavel</mat-icon>
          <img *ngIf="row.PCD && tipoClassificacao === 'todos' && exibirIconePCD()" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
          <br />
          <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="nascimento">
        <th class="col-birthdate" mat-header-cell *matHeaderCellDef>Nascimento</th>
        <td class="col-birthdate" mat-cell *matCellDef="let row">
          {{ row.nascimento }}
        </td>
      </ng-container>

      <ng-container matColumnDef="conceito">
        <th class="col-grade" mat-header-cell *matHeaderCellDef>Conceito</th>
        <td class="col-grade" mat-cell *matCellDef="let row">
          <div *ngIf="row.estaEmpatado && !getClassificacaoInfo()" class="grade-container">
            <input
              class="grade-input"
              matInput
              maxlength="1"
              class="w-50"
              [(ngModel)]="row.conceito"
              (focus)="row.conceitoAnterior = row.conceito"
              (keypress)="permitirSomenteLetra($event)"
              (blur)="enviarConceito(row)"
              (keydown.enter)="enviarConceito(row)"
              [ngClass]="{'invalid-grade': !row.conceito}"
            />
            <button 
              *ngIf="row.justificativa"
              mat-icon-button 
              color="primary"
              (click)="mostrarJustificativa(row.justificativa)"
              matTooltip="Justificativa"
              class="icon-sm">
              <mat-icon>description</mat-icon>
            </button>
          </div>
          <div *ngIf="row.conceito && getClassificacaoInfo()" class="grade-container">
            <span>{{ row.conceito }}</span>
            <button 
              *ngIf="row.justificativa"
              mat-icon-button 
              color="primary"
              (click)="mostrarJustificativa(row.justificativa)"
              matTooltip="Justificativa"
              class="icon-sm">
              <mat-icon>description</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="indicacoes">
        <th class="col-nominations" mat-header-cell *matHeaderCellDef>Indicações</th>
        <td class="col-nominations" mat-cell *matCellDef="let row">{{ row.posicaoMaisRecorrente }}º: {{row.quantidadeNaPosicaoMaisRecorrente}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasGrid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasGrid;"></tr>
    </table>
  </div>

  <div class="classification-block" *ngIf="dataSourceClassificacao && dataSourceClassificacao.data && dataSourceClassificacao.data.length > 0">
    <div class="title">
      <mat-icon>people</mat-icon>
      <span>Classificação por Examinador</span>
    </div>
    <table mat-table [dataSource]="dataSourceClassificacao" class="full-width-table">
      
      <ng-container matColumnDef="posicao">
        <th class="col-classification" mat-header-cell *matHeaderCellDef rowspan="2">Classificação</th>
        <td class="col-classification" mat-cell *matCellDef="let linha"> {{linha.posicao}}º </td>
      </ng-container>
      
      <ng-container *ngFor="let coluna of colunasClassificacaoGrid">
        <ng-container *ngIf="coluna !== 'posicao'">
          <ng-container [matColumnDef]="coluna + '_nome'">
            <th mat-header-cell *matHeaderCellDef colspan="1" [matTooltip]="'Matrícula: ' + getExaminadorMatricula(coluna)">Prof.(a) Dr.(a) {{getExaminadorDisplayName(coluna)}} </th>
            <td mat-cell *matCellDef="let linha">
              <strong>{{ linha[coluna + '_nome'] }}</strong><br />
              <span *ngIf="linha[coluna + '_nomeSocial']" class="nome-social">/ {{ linha[coluna + '_nomeSocial'] }}</span>
            </td>
          </ng-container>
          <ng-container [matColumnDef]="coluna + '_media'">
            <th mat-header-cell *matHeaderCellDef colspan="1">Média </th>
            <td mat-cell *matCellDef="let linha"> {{linha[coluna + '_media'] || '-'}} </td>
          </ng-container>
          <ng-container [matColumnDef]="coluna + '_conceito'">
            <th mat-header-cell *matHeaderCellDef colspan="1">Conceito</th>
            <td mat-cell *matCellDef="let linha">
              <div *ngIf="linha[coluna + '_conceito']" style="display: inline-flex; align-items: center; gap: 2px; vertical-align: middle;">
                <span>{{ linha[coluna + '_conceito'] }}</span>
                <button
                  *ngIf="linha[coluna + '_justificativa']"
                  mat-icon-button
                  color="primary"
                  (click)="mostrarJustificativa(linha[coluna + '_justificativa'])"
                  matTooltip="Ver justificativa de desempate"
                  class="icon-sm">
                  <mat-icon>description</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>
        </ng-container>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="headerRow"></tr>
      <tr mat-row *matRowDef="let row; columns: headerRow;"></tr>
    </table>
  </div>

  <div *ngIf="tiposProva.length > 0" class="scores-by-type">
    <div class="title">
      <mat-icon>assessment</mat-icon>
      <span>Resultados por prova</span>
    </div>
    
    <div class="exam-type-buttons">
      <button 
        *ngFor="let tipo of tiposProva" 
        mat-raised-button 
        [color]="tipoProvaSelecionado === tipo ? 'primary' : ''"
        (click)="selecionarTipoProva(tipo)"
        class="mr-8 mb-8">
        {{ tipo }}
      </button>
    </div>

    <div *ngIf="tipoProvaSelecionado" class="scores-type-table">
      <table mat-table [dataSource]="notasPorTipo[tipoProvaSelecionado]" class="mat-elevation-z8">

        <ng-container matColumnDef="inscricaoId">
          <th mat-header-cell *matHeaderCellDef>Inscrição</th>
          <td mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
        </ng-container>

        <ng-container matColumnDef="nome">
          <th mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
          <td mat-cell *matCellDef="let row">
            <strong>{{ row.nomeSocial || row.nome }}</strong><br />
            <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
          </td>
        </ng-container>

        <ng-container *ngFor="let coluna of colunasPorTipo[tipoProvaSelecionado]">
          <ng-container *ngIf="coluna !== 'nome' && coluna !== 'inscricaoId'" [matColumnDef]="coluna">
            <th mat-header-cell *matHeaderCellDef [matTooltip]="getComissaoMatricula(coluna) ? 'Matrícula: ' + getComissaoMatricula(coluna) : 'Externo Unicamp'">Prof.(a) Dr.(a) {{ getComissaoNome(coluna) }}</th>
            <td mat-cell *matCellDef="let row">{{ row[coluna] }}</td>
          </ng-container>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="colunasPorTipo[tipoProvaSelecionado]"></tr>
        <tr mat-row *matRowDef="let row; columns: colunasPorTipo[tipoProvaSelecionado]"></tr>
      </table>
    </div>
  </div>

  <div class="first-phase-block" *ngIf="dataSourceFase1 && dataSourceFase1.data && dataSourceFase1.data.length > 0">
    <div class="title">
      <mat-icon>looks_one</mat-icon>
      <span>Resultados da Primeira Fase</span>
    </div>
    <table mat-table [dataSource]="dataSourceFase1" class="mat-elevation-z8">

      <ng-container matColumnDef="classificacao">
        <th class="col-classification" mat-header-cell *matHeaderCellDef>Classificação</th>
        <td class="col-classification" mat-cell *matCellDef="let row">
          <mat-icon *ngIf="row.estaEliminado" class="eliminated-icon" matTooltip="Não Habilitado">close</mat-icon>
          <span *ngIf="!row.estaEliminado">{{ row.classificacao }}º</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="inscricaoId">
        <th class="col-registration" mat-header-cell *matHeaderCellDef>Inscrição</th>
        <td class="col-registration" mat-cell *matCellDef="let row">{{ row.inscricaoId }}</td>
      </ng-container>

      <ng-container matColumnDef="nome">
        <th class="col-name" mat-header-cell *matHeaderCellDef>Nome / Nome Social</th>
        <td class="col-name" mat-cell *matCellDef="let row">
          <strong>{{ row.nomeSocial || row.nome }}</strong>
          <img *ngIf="row.PCD && exibirIconePCD()" src="assets/icons/Accessibility_logo.png" class="accessibility-icon" matTooltip="Pessoa com Deficiência" alt="Pessoa com Deficiência">
          <br />
          <span *ngIf="row.nomeSocial" class="nome-social">/ {{ row.nomeSocial }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="nascimento">
        <th class="col-birthdate" mat-header-cell *matHeaderCellDef>Nascimento</th>
        <td class="col-birthdate" mat-cell *matCellDef="let row">
          {{ row.nascimento }}
        </td>
      </ng-container>

      <ng-container matColumnDef="mediaFinal">
        <th class="col-averageFinal" mat-header-cell *matHeaderCellDef>Média Final</th>
        <td class="col-averageFinal" mat-cell *matCellDef="let row">{{ row.mediaFinal | number:'1.2-2' }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="colunasFase1Grid"></tr>
      <tr mat-row *matRowDef="let row; columns: colunasFase1Grid;"></tr>

    </table>
  </div>
</div>

<div *ngIf="exibirBotaoConsolidarFase1 && !isExaminadorView" class="text-center mt-20">
  <button
    mat-raised-button
    color="primary"
    [class.pulse-animation]="!isConsolidando && dataSourceFase1.data.length !== 0"
    [disabled]="isConsolidando || dataSourceFase1.data.length === 0"
    (click)="consolidarClassificacaoFase1()">
    <span *ngIf="!isConsolidando">Consolidar Classificação</span>
    <span *ngIf="isConsolidando">
      <i class="fa fa-spinner fa-spin"></i> Processando...
    </span>
  </button>
</div>

<div *ngIf="!getClassificacaoInfo() && !exibirBotaoConsolidarFase1 && !isExaminadorView" class="text-center mt-20">
  <button
    mat-raised-button
    color="primary"
    [class.pulse-animation]="!isConsolidando && dataSource.data.length !== 0"
    [disabled]="isConsolidando || dataSource.data.length === 0"
    (click)="consolidarClassificacao()">
    <span *ngIf="!isConsolidando">Consolidar Classificação</span>
    <span *ngIf="isConsolidando">
      <i class="fa fa-spinner fa-spin"></i> Processando...
    </span>
  </button>
</div>

<div fxLayout="row" fxLayoutAlign="space-between center" class="mt-20">
  <button *ngIf="exibirBotaoVisualizarFase1" mat-raised-button color="accent" (click)="visualizarClassificacaoFase1()" matTooltip="Visualizar Classificação da Fase 1">
    <mat-icon>visibility</mat-icon>
    Visualizar Classificação da Fase 1
  </button>
  <div *ngIf="!exibirBotaoVisualizarFase1"></div>
  <button mat-raised-button color="primary" (click)="voltar()" matTooltip="Voltar para a listagem de provas">
    <mat-icon>arrow_back</mat-icon>
    Voltar
  </button>
</div>
